import {createSelector} from 'reselect';

const forumCategoriesItemsSelector = state => state.forums.data;
const forumCategoriesChildrensSelector= state => state.forumCategories;
const forumIdSelector = (_, props) => props.forumId;

export const categoriesByForumId = createSelector(
    forumCategoriesItemsSelector,
    forumIdSelector,
    (forumChildrens, forumId) => Object.values(forumChildrens).filter((forumChildren) => forumChildren._id === forumId)
);

export const categoriesObjectByForumId= createSelector(
    forumCategoriesChildrensSelector,
    forumIdSelector,
    (category, key) => category[key] || category['default']
);

export const categoriesKeysByForumId = createSelector(
    categoriesByForumId,
    categories => categories.map(categories => categories._id)
);